<template lang="pug">
div.menu(v-if="showMenu")
	input.menu-input(type="text"
		maxlength="1"
		ref="menuInput"
		@keyup="handleKeys($event)"
		@blur="handleBlur()")
	v-btn.menu-button(
		v-for="(transaction, idx) in availableTransactions"
		:color="color(transaction)"
		:key="transaction.id"
		:dark="transaction.id !== hoverID"
		large
		style="height: 60px;"
		@click="handleSelection(transaction)"
	)
		v-icon(left) {{transaction.icon}}
		span.font-weight-bold {{transaction.displayName}}
		span.caption.pl-1.font-weight-light {{'(' + (idx + 1) + ')'}} 
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
    name: 'dte-menu',
    props: {},
    data: function() {
        return {
            hoverID: 0,
        }
    },
    computed: {
        ...mapState('TransactionModule', {
            availableTransactions: 'availableTransactions',
            showMenu: 'showMenu'
        }),
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
    },
    methods: {
        ...mapActions('TransactionModule', {
            setTransactionType: 'setTransactionType',
            setShowMenu: 'setShowMenu'
        }),
        color(transaction){
            if(transaction.id === this.hoverID) return 'grey lighten-3'
            return transaction.color
        },
        handleKeys(e){
            e.preventDefault()
            e.stopPropagation()
            // Handle Esc key
            if(e.key === "Escape") this.setShowMenu(false)
            let code = e.keyCode
            //Handle up down keys
            if(code === 38 && this.hoverID > 1) this.hoverID--
            if(code === 40 && this.hoverID < 6) this.hoverID++
            // Handle Enter Key
            if(code === 13) this.handleSelection(this.availableTransactions.find(transaction => transaction.id === this.hoverID))
            // Handle numbers from 1 to 6
            if(code >= 49 && code <= 54){
                let num = parseInt(e.key)
                this.handleSelection({id:num})
                if(num === 6){
                    this.$router.replace('/cambio')
                }
            }
        },
        handleSelection(transaction){
            this.setTransactionType(transaction.id)
            this.setShowMenu(false)
        },
        handleBlur(){
            setTimeout(() => {this.setShowMenu(false)}, 100)
            setTimeout(() => {
                if (document.activeElement.tagName === 'BODY') {
                    this.$nextTick(() => {
                        document.getElementById('barcode-scanner-input').focus()
                    })
                }
            }, 200)
        }
    },
    watch: {
        showMenu(val){
            if(val){
                this.$nextTick(() => this.$refs.menuInput.focus())
                this.hoverID = this.activeTransaction.id
            }
        },
        activeTransaction(){
            this.hoverID = this.activeTransaction.id
        }
    },
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function(){
        this.hoverID = this.activeTransaction.id
    },
    // beforeMount: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.menu {
    transition: 0ms !important;
    display: flex;
    flex-direction: column;
    width: 220px;
    position: fixed;
    top: 64px;
    left: 24px;
    z-index: 30;
    .menu-input{
        position: fixed;
        left: -1000px;
    }
    .menu-button {
        margin: 0px 0px 0px 0px !important;
        transition: 0ms !important;
    }
}
</style>
